<template>
  <v-avatar v-if="image" :image="image" :size="size" tile v-bind="$attrs" />
  <v-avatar v-else :size="size" tile v-bind="$attrs">
    <NodeIcon :height="size" type="folder" :width="size" />
  </v-avatar>
</template>

<script lang="ts" setup>
import NodeIcon from '@/components/node/NodeIcon.vue'

defineProps({
  name: {
    type: String,
    default: 'folder-icon',
  },
  size: {
    type: [String, Number],
    default: 20,
  },
  image: {
    type: String,
    default: undefined,
  },
})
</script>
